import './App.css';
import Navbar from '../src/components/Navbar';
import Home from './components/Home';
import Bms from './components/Bms';
import Footer from './components/Footer';
import Info from './components/Info';
import Ev from './components/Ev';
import Iot from './components/Iot';
import Bc from './components/Bc';
import Myfooter from './components/Myfooter';
import { Routes, Route, useLocation } from "react-router-dom"
import { API_URL } from './components/General/General';
import { useEffect, useState } from 'react';
import PrivacyPolicy from './components/Legal/PrivacyPolicy';
import RefundPolicy from './components/Legal/RefundPolicy';
import TnC from './components/Legal/TnC';
import FAQ from './components/Legal/FAQ';
import Overlay from "./components/Overlay/Overlay";

function App() {
  const [evChargerList, setEvChargerList] = useState()
  const [bmsList, setBmsList] = useState()
  const [batteryChargerList, setBatteryChargerList] = useState()
  const [iotList, setIoTList] = useState()
  const location = useLocation();
  const [showOverlay, setShowOverlay] = useState(false);
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => storeIpData(data))
      .catch((error) => console.error("IP Error"));
  }, []);
  useEffect(() => {
    const isHomePage = location.pathname === "/";
    const overlayShown = sessionStorage.getItem("overlayShown");

    if (isHomePage && !overlayShown) {
      setShowOverlay(true);
      sessionStorage.setItem("overlayShown", "true");
    }
  }, [location]);
  useEffect(() => {
    getEvChargerList()
    getBatteryChargerList()
    getBMSList()
    getIoTList()
  }, [])
  function getEvChargerList() {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + window.localStorage.getItem("token")
    );
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
    };
    fetch(API_URL + "website/products/?type=evc", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status)
          setEvChargerList(result.data)
      })
      .catch((error) => console.log("error", error));
  }
  function getBatteryChargerList() {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + window.localStorage.getItem("token")
    );
    let requestOptions = {
      method: "GET",
      headers: myHeaders,

    };
    fetch(API_URL + "website/products/?type=bc", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status)
          setBatteryChargerList(result.data)
      })
      .catch((error) => console.log("error", error));
  }
  function getBMSList() {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + window.localStorage.getItem("token")
    );
    let requestOptions = {
      method: "GET",
      headers: myHeaders,

    };
    fetch(API_URL + "website/products/?type=bms", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status)
          setBmsList(result.data)
      })
      .catch((error) => console.log("error", error));
  }
  function getIoTList() {
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + window.localStorage.getItem("token")
    );
    let requestOptions = {
      method: "GET",
      headers: myHeaders,

    };
    fetch(API_URL + "website/products/?type=iot", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status)
          setIoTList(result.data)
      })
      .catch((error) => console.log("error", error));
  }
  const storeIpData = (data) => {
    const headers = new Headers()
    headers.append("Content-Type", "application/json")
    headers.append(
      "Authorization",
      "Bearer " + window.localStorage.getItem("token")
    );
    const requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        data: data
      })
    };
    fetch(API_URL + "website/viewers/", requestOptions).then((res) => res.json()).then((result) => {
      console.log('ip success');

    }).catch(err => console.log(err)
    )
  }

  return (
    <div className="App">
      <Navbar />
      {showOverlay && <Overlay onClose={() => setShowOverlay(false)} />}
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route exact path='/electric-vehicle-charger' element={<Ev evChargerList={evChargerList} />} />
        <Route exact path='/battery-management-system' element={<Bms bmsList={bmsList} />} />
        <Route exact path='/bms' element={<Bms bmsList={bmsList} />} />
        <Route exact path='/battery-charger' element={<Bc batteryChargerList={batteryChargerList} />} />
        <Route exact path='/iot-telematics' element={<Iot iotList={iotList} />} />
        <Route exact path='/contact' element={<Info />} />
        <Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route exact path='/refund-policy' element={<RefundPolicy />} />
        <Route exact path='/terms-and-conditions' element={<TnC />} />
        <Route exact path='/faq' element={<FAQ />} />
      </Routes>
      <Myfooter>
        <Footer />
      </Myfooter>
    </div>
  );
}

export default App;
